import * as Yup from "yup";
import { checkCapital, checkLength, checkLowercase, checkNumber, checkSpecial, requiredFieldMessage } from "../utils";

export const UserManagementSchema = Yup.object().shape({
  first_name: Yup.string()
    .min(2, "Please, add at least 2 symbols")
    .max(50, "Please, make it shorter than 50 symbols")
    .required(requiredFieldMessage),
  last_name: Yup.string()
    .min(2, "Please, add at least 2 symbols")
    .max(50, "Please, make it shorter than 50 symbols")
    .required(requiredFieldMessage),
  email: Yup.string().email("Please, enter the correct email").required(requiredFieldMessage),
  telephone: Yup.string()
    .min(10, "Phone number should be at least 10 characters")
    .max(15, "Phone number shouldn't be longer than 15 characters")
    .required(requiredFieldMessage),
  roles: Yup.array(),
});

export const LoginSchema = Yup.object().shape({
  email: Yup.string()
    .email("Hmmm, something not quite right with your email address.")
    .required("Whoops, we're going to need your email to log you in 🤷"),
  password: Yup.string().required("Hey, your password is kinda 'need to know' stuff...."),
});

export const ResetPasswordSchema = Yup.object().shape({
  email: Yup.string()
    .email("Hmmm, something not quite right with your email address.")
    .required("Whoops, we're going to need your email to help you out 🤷"),
});

export const NewPasswordSchema = Yup.object().shape({
  password: Yup.string()
    .required("New password is required")
    .test(
      "password",
      "☝🏽oh, that password won’t work, (Fort Knox remember....)",
      (value) =>
        value &&
        checkLength(value) &&
        checkLowercase(value) &&
        checkCapital(value) &&
        checkNumber(value) &&
        checkSpecial(value)
    ),
  confirm_password: Yup.string()
    .required("Password confirmation is required")
    .oneOf([Yup.ref("password")], "Probably a typo but those two new passwords don't quite match."),
  tos: Yup.boolean().required().oneOf([true], "Please, agree to the Terms of Service"),
});
